import { w3cwebsocket as WebSocket } from 'websocket';
import { Auth } from 'aws-amplify';

type AppointmentGuid = string;
type MessageBlob = object;

export const sendToParticipants = async (
  appointment_id: AppointmentGuid,
  message: MessageBlob,
  twilioBaseUrl: string,
  clinicianGUID: string,
  patientGUID: string
) => {
  const tokens = await Auth.currentSession();
  const token = tokens.getIdToken().getJwtToken();
  const u = new URL(twilioBaseUrl);

  if (!appointment_id) {
    return;
  }

  u.searchParams.append('role', 'clientAdmin');
  u.searchParams.append('appointment_id', appointment_id);
  u.searchParams.append('authorizer', token);

  const ws = new WebSocket(u.toString());

  const sendAction = (action, message) => {
    const msg = {
      action,
      appointmentID: parseInt(appointment_id),
      role: 'clientAdmin',
      message,
      clinicianGUID: clinicianGUID,
      participantGUID: patientGUID
    };
    ws.send(JSON.stringify(msg));
  };

  ws.onopen = () => {
    sendAction('control', `control&${JSON.stringify({ ...message, timestamp: new Date(), sequenceNumber: 0 })}`);
    ws.close();
  };
};
